import _ from 'underscore';

class ApiPlugin {
  /* eslint-disable */
  static init() {}
  static before(config) {}
  static after(res, config, error) {}
  /* eslint-enable */

  /**
   * Helper function to process single object or array
   *
   * @param   data
   * @param   callback
   * @returns
   */
  static process(data, callback) {
    if (data.content && Array.isArray(data.content)) {
      // Process paged results of list call
      data.content = data.content.map((obj) => callback(obj));
      return data;
    }

    if (Array.isArray(data)) {
      // Process non-paged array result
      // Non-paged list call
      return data.map((obj) => callback(obj));
    }

    if (_.isObject(data)) {
      // Finally, process a single object - get by ID
      return callback(data);
    }

    return data;
  }

  static toJSON(data) {
    return _.isObject(data) && _.isFunction(data.toJSON) ? data.toJSON() : data;
  }
}

// Handles unwrapping of the ApiResponse
class ApiResponsePlugin extends ApiPlugin {
  static after(res, config, error) {
    if (error || !this.unwrap || !(res && res.data && res.data.status && res.data.result)) {
      // not unwrapping or doesn't look like our standard ApiResponse
      if (this.model && _.has(res, 'data')) {
        // return inner data, which should always be present from an axios
        // response object.
        // only when we have a model class, so we don't break existing API calls
        // that expect an inner data.
        return res.data;
      }
      return res;
    }

    const { data } = res;

    if (config.respondHeaders) {
      // copy the headers from response
      data.headers = res.headers;
    }

    if (data.status >= 300) {
      return Promise.reject(data);
    }

    return config.respondHeaders ? data : data.result;
  }
}

// Plugin which handles serializing and deserializing the request/response data
// using a configured Model class
class ModelPlugin extends ApiPlugin {
  static before(config) {
    if (this.model === null || !config.data) {
      return;
    }
    // eslint-disable-next-line no-param-reassign
    config.data = ApiPlugin.process(config.data, ApiPlugin.toJSON);
  }

  static after(res, config, error) {
    if (!this.model || error) {
      return res;
    }

    // eslint-disable-next-line new-cap
    return ApiPlugin.process(res, (data) => new this.model(data));
  }
}

export { ApiPlugin, ApiResponsePlugin, ModelPlugin };
